<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    @click="$emit('click')"
  >
    <path
      d="M10 19H14V17.1429H10V19ZM6 13.4286H18V11.5714H6V13.4286ZM3 6V7.85714H21V6H3Z"
    />
    <title v-if="title !== ''">{{ title }}</title>
  </svg>
</template>
<script>
export default {
  name: "FiltrosIcon",
};
</script>
